import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { Card } from '../../common';

const StatsCard = ({
  title,
  value,
  icon: Icon,
  trend,
  trendValue,
  subtitle,
  color = 'primary',
}) => {
  const colors = {
    primary: {
      bg: 'bg-primary-50',
      icon: 'text-primary-600',
      gradient: 'from-primary-400 to-primary-500',
    },
    success: {
      bg: 'bg-green-50',
      icon: 'text-green-600',
      gradient: 'from-green-400 to-green-500',
    },
    warning: {
      bg: 'bg-yellow-50',
      icon: 'text-yellow-600',
      gradient: 'from-yellow-400 to-yellow-500',
    },
    danger: {
      bg: 'bg-red-50',
      icon: 'text-red-600',
      gradient: 'from-red-400 to-red-500',
    },
    info: {
      bg: 'bg-blue-50',
      icon: 'text-blue-600',
      gradient: 'from-blue-400 to-blue-500',
    },
  };

  const selectedColor = colors[color] || colors.primary;

  return (
    <Card hoverable className="overflow-hidden">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
          <p className="text-3xl font-bold text-gray-900 mb-2">{value}</p>
          
          {trend && (
            <div className="flex items-center gap-1">
              {trend === 'up' ? (
                <TrendingUp className="w-4 h-4 text-green-600" />
              ) : (
                <TrendingDown className="w-4 h-4 text-red-600" />
              )}
              <span
                className={`text-sm font-medium ${
                  trend === 'up' ? 'text-green-600' : 'text-red-600'
                }`}
              >
                {trendValue}
              </span>
              {subtitle && (
                <span className="text-sm text-gray-500 ml-1">{subtitle}</span>
              )}
            </div>
          )}
          
          {!trend && subtitle && (
            <p className="text-sm text-gray-500">{subtitle}</p>
          )}
        </div>

        {Icon && (
          <div
            className={`w-12 h-12 rounded-xl ${selectedColor.bg} flex items-center justify-center`}
          >
            <Icon className={`w-6 h-6 ${selectedColor.icon}`} />
          </div>
        )}
      </div>

      {/* Progress bar opcional */}
      <div className="mt-4 h-1 bg-gray-100 rounded-full overflow-hidden">
        <div
          className={`h-full bg-gradient-to-r ${selectedColor.gradient} transition-all duration-500`}
          style={{ width: '75%' }}
        />
      </div>
    </Card>
  );
};

export default StatsCard;